// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"logo_logoLink__3GFnF","logo":"logo_logo__2xZe-","header":"logo_header__YFIR0"};